<div 
  class="wrapper-inner"
  [ngClass]="{ 'vertical-menu-tooltip-place': (settings.theme.menuType == 'mini' && settings.theme.menu == 'vertical'),
               'horizontal-menu-tooltip-place': (settings.theme.menuType == 'mini' && settings.theme.menu == 'horizontal') }"
>
  <app-header></app-header>

  <div 
    class="d-flex h-100" 
    [ngClass]="{'flex-row': settings.theme.menu == 'vertical', 'flex-column': settings.theme.menu != 'vertical'}"
  >
    <app-side-nav class="mt-1"></app-side-nav>
   
    <div class="main-content">
      <app-export-to-excel data-testid="application-container-export-to-excel"></app-export-to-excel>
      <ng-content></ng-content>
    </div>
  </div>

</div>
<app-footer></app-footer>



// WEBPACK FOOTER //
// ./src/app/core/components/application-container/application-container.component.html